<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">Dashboard</h4>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="4">
                <DashboardSheet
                    title="Open Purchase Orders"
                    icon="mdi-chart-arc"
                    icon-color="warning"
                    :value="openOrders"
                    >
                    <template v-slot:[`value`]="{value}">
                        <div class="text-h4">{{value ? millify(value) : 0 }}</div>
                    </template>
                </DashboardSheet>
            </v-col>
            <v-col cols="12" md="4">
                <DashboardSheet
                    :title="purchasing.title"
                    icon="mdi-chart-areaspline"
                    icon-color="#32a4a8"
                    :value="purchasing.currentMonth"
                    >
                    <template v-slot:[`value`]="{value}">
                        <div class="text-h4">{{ value ? millify(value) : 0 }}</div>
                    </template>
                </DashboardSheet>
            </v-col>
            <v-col cols="12" md="4">
                <DashboardSheet
                    :title="outStandingPaymnets.title"
                    icon="mdi-currency-usd"
                    icon-color="#68BE25"
                    :value="outStandingPaymnets.base_amount"
                    >
                    <template v-slot:[`value`]="{value}">
                        <div class="text-h4">{{ value ? millify(value) : 0 }}</div>
                    </template>
                </DashboardSheet>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-sheet
                    outlined
                    rounded="lg"
                    class="pa-4"
                    >
                    <div class="font-weight-bold mb-4 text-center">Total Purchasing Monthly</div>
                    <div style="height: 300px">
                        <canvas ref="buyingByMonthChart"></canvas>
                    </div>
                </v-sheet>
            </v-col>
            <v-col cols="12" md="6">
                <v-sheet
                    outlined
                    rounded="lg"
                    class="pa-4"
                    >
                    <div class="font-weight-bold mb-4 text-center">Purchasing By Categories Monthly</div>
                    <div style="height: 300px">
                        <canvas  ref="buyingByCategoriesMonthly"></canvas>
                    </div>
                </v-sheet>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Chart from 'chart.js'
import millify from 'millify';
import { formatNumber } from 'accounting';
import DashboardSheet from './../../components/dashboard/DashboardSheet.vue';
import {
    getOpenOrdres,
    getBuyingByMonth,
    getBuyingByCategoriesMonthly,
    getOutstandingPayment } from '../../services/purchase/dashboard';
import moment from 'moment';

export default {
    name: "DashboardView",
    components: {
        DashboardSheet
    },
    data() {
        return {
            openOrders: 0,
            outStandingPaymnets: 0,
            purchasing: {
                title: '',
                perviousMonth: 0,
                currentMonth: 0,
            },
            buyingByMonthChart: null,
            buyingByCategoriesMonthlyChart: null,
        }
    },
    computed: {
        isUp() {
            return ( this.buyingThisMonth - this.perviousMonth ) > 0 ? true : false;
        }
    },
    methods: {
        millify,
        formatNumber,
        async handleOpenOrders() {
            let res = await getOpenOrdres();
            this.openOrders = parseInt(res.data);
        },
        async handleOustandingPayment() {

            let currentMonth = moment().startOf('month').format('YYYY-MM-DD');
            let perviousMonth = moment().endOf('month').format('YYYY-MM-DD');

            let { data } = await getOutstandingPayment({currentMonth, perviousMonth});
            this.outStandingPaymnets = {
                base_amount : data.base_amount,
                title: 'Payments Of ' + data.month
            };
        },
        async handleBuyingThisMonth() {

            let { data } = await getBuyingByMonth();
            let now  = moment().startOf('month').format('M');

            let currentMonth = data.filter((each) => each.month == now);
            let perviousMonth  = data.filter((each) => each.month_name == now - 1);

            this.purchasing.title = "Purchasing Of " +  moment().startOf('month').format('MMMM');
            this.purchasing.currentMonth = currentMonth.length > 0 ? currentMonth[0].value : 0.0;
            this.purchasing.perviousMonth = perviousMonth.length > 0 ? perviousMonth[0].value : 0.0;
        },
        async fetchBuyingByMonth() {
            let { data } = await getBuyingByMonth();
            this.buyingByMonthChart.data.labels = data.map(each => each.month_name);
            this.buyingByMonthChart.data.datasets = [{
                data: data.map(each => each.value),
                fill: false,
                backgroundColor: '#2596be',
            }]
            this.buyingByMonthChart.update();
        },
        async renderBuyingByMonthChart() {
            this.buyingByMonthChart = new Chart(this.$refs.buyingByMonthChart, {
                type: 'bar',
                data: {
                    labels: [],
                    datasets: []
                },
                 options: {
                    maintainAspectRatio: false,
                    responsive: true,
                    legend: {
                        display: false
                    },
                    tooltips: {
                        callbacks: {
                            label: (tooltipItem) => {
                              return `Amount ${millify(tooltipItem.value)}`
                            }
                        }
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                callback: function(value) {
                                    return millify(value);
                                }
                            }
                        }],
                        xAxes: [{
                            ticks: {
                                display: true
                            }
                        }]
                    }
                },
            });
        },
        async renderBuyingByCategoriesMonthlyChart() {

            let { data } = await getBuyingByCategoriesMonthly();

            let groups = Array.from(new Set(data.map(each => each.name)));
            let months = Array.from(new Set(data.map(each => each.month)));

            let result = [];

            months.forEach(month => {
                groups.forEach(group => {
                    let record = data.find(each => each.month == month && each.name == group);
                    result.push({
                        month,
                        group,
                        value: record ? record.value : 0
                    })
                })
            })

            let datasets = groups.map((group, index) => {
                return {
                    label: group,
                    data: result.filter(each => each.group == group).map(each => ({ y: each.value, x: each.month })),
                    borderColor:[
                            'rgba(255, 99, 132, 0.8)',
                            'rgba(255, 159, 64, 0.8)',
                            'rgba(255, 205, 86, 0.8)',
                            'rgba(75, 192, 192, 0.8)',
                            'rgba(54, 162, 235, 0.8)',
                            'rgba(153, 102, 255, 0.8)',
                            'rgba(201, 203, 207, 0.8)'
                        ][index],
                    fill: false
                }
            })

            this.buyingByCategoriesMonthly = new Chart(this.$refs.buyingByCategoriesMonthly, {
                type: 'line',
                data: {
                    labels: months,
                    datasets
                },
                 options: {
                    maintainAspectRatio: false,
                    responsive: true,
                    legend: {
                        display: true
                    },
                    tooltips: {
                        callbacks: {
                            label: (tooltipItem) => {
                              return `${groups[tooltipItem.datasetIndex]} Amount ${millify(tooltipItem.value)}`
                            }
                        }
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                callback: function(value) {
                                    return millify(value);
                                }
                            }
                        }],
                        xAxes: [{
                            ticks: {
                                display: true
                            }
                        }]
                    }
                },
            });
        }
    },
    created() {
        this.handleOpenOrders();
        this.handleBuyingThisMonth();
        this.fetchBuyingByMonth();
        this.handleOustandingPayment();
    },
    mounted() {
        this.renderBuyingByMonthChart();
        this.renderBuyingByCategoriesMonthlyChart();
    }
}
</script>

<style>

</style>